export const brandQualityMockData = {
  manufacturingStandards: {
    title: "มาตรฐานการผลิต\nและการจัดการสิ่งแวดล้อม",
    content: `บริษัท ปลาร้าเชฟไพรฑูรย์ ฟู้ดโปรดักส์ จำกัด ผู้ผลิตและจัดจำหน่ายผลิตภัณฑ์น้ำปลาร้าเชฟไพรฑูรย์ น้ำจิ้มเนื้อวัวเชฟไพรฑูรย์ และผลิตภัณฑ์อื่น ภายใต้เครื่องหมายการค้า เชฟไพรฑูรย์

ผลิตภัณฑ์ของเราผลิตโดยโรงงานที่มีมาตรฐานและได้อนุญาตเป็นโรงงานผลิตอาหาร มีการทดสอบรับรองมาตรฐานการผลิตจากหน่วยงานภาครัฐ รวมถึงมีระบบกการจัดการของเสียที่ทันสมัย ก่อนปล่อยออกสู่ธรรมชาติ ช่วยป้องกันการเกิดปัญหาน้ำเสีย กลิ่นเหม็น

โดยมีการสุ่มตรวจสอบทั่วบริเวณพื้นที่โรงงาน ด้วยเครื่องมือที่มีมาตรฐานของหน่วยงานที่เกี่ยวข้องอยู่เสมอ
พร้อมทั้งบริษัทฯ มีการออกสำรวจความคิดเห็นและสอบถามปัญหาของผู้คน ในชุมชนบริเวณใกล้เคียงเป็นประจำ ทำให้โรงงานของเราสามารถอยู่ร่วมกับชุมชนได้อย่างปลอดภัย`,
    factoryImage: "/images/brand-quality/factory-aerial-view.png",
    videoUrl: "https://firebasestorage.googleapis.com/v0/b/cool-splice-468214-q7.firebasestorage.app/o/video%2Ffactory_tour.mp4?alt=media&token=eb0647ac-e379-4fe9-a20c-bfd810fe615c",
  },
  certifications: {
    title: "เอกสารรับรองมาตรฐาน",
    badges: [
      {
        image: "/images/brand-quality/food-license-badge.png",
        title: "ใบอนุญาตผลิตอาหาร",
        documentImage: "/images/brand-quality/food-license.jpg",
      },
      {
        image: "/images/brand-quality/halal-certification-badge.png",
        title: "หนังสืออนุญาตใช้เครื่องหมายฮาลาล",
        documentImage: "/images/brand-quality/halal-license.jpg",
      },
      {
        image: "/images/brand-quality/otop-4-star-badge.png",
        title: "สินค้า O-TOP 4 ดาว",
        documentImage: "/images/brand-quality/otop-4star-license.jpg",
      },
      {
        image: "/images/brand-quality/green-industry-badge.png",
        title: "อุตสาหกรรมสีเขียว",
        documentImage: "/images/brand-quality/green-industry-license.jpg",
      },
      {
        image: "/images/brand-quality/ghp-badge.png",
        title: "GHPs",
        documentImage: "/images/brand-quality/ghp-license.jpg",
      },
      {
        image: "/images/brand-quality/haccp-badge.png",
        title: "HACCP",
        documentImage: "/images/brand-quality/haccp-license.jpg",
      },
    ]
  }
};